import { useNavigate } from "react-router-dom";

const INK_72 = "var(--ink-72)";

export default function LegalLayout({ title, italic, eyebrow, lastUpdated, children, testid }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen px-5 md:px-10 py-6 md:py-10" style={{ background: "var(--bg)", color: "var(--ink)" }} data-testid={testid}>
      <div className="max-w-4xl mx-auto mb-10 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center gap-2.5 hover:opacity-80 transition" data-testid="legal-home-link">
          <span className="seal-dot" />
          <span className="font-heading text-lg" style={{ fontVariationSettings: "'opsz' 32, 'wght' 500" }}>PintaFlow</span>
        </button>
        <span className="text-[10px] uppercase tracking-[0.24em] px-2.5 py-1 rounded-full" style={{ background: "rgba(216,168,87,0.10)", border: "1px solid rgba(216,168,87,0.35)", color: "var(--seal)" }}>
          Private Beta
        </span>
      </div>

      <div className="max-w-3xl mx-auto">
        <div className="eyebrow mb-4"><span className="seal-dot mr-2 align-middle" /> {eyebrow}</div>
        <h1
          className="font-heading text-4xl md:text-5xl leading-[1.04]"
          style={{ fontVariationSettings: "'opsz' 96, 'wght' 450" }}
        >
          {title} <span className="font-display-italic">{italic}</span>
        </h1>
        <div className="text-xs mt-4" style={{ color: INK_72, opacity: 0.7 }}>
          Last updated: {lastUpdated}
        </div>

        <div className="mt-10 space-y-7 text-[15px] leading-[1.78]" style={{ color: INK_72 }}>
          {children}
        </div>

        <div className="mt-16 pt-8 text-xs" style={{ borderTop: "1px solid var(--ink-22)", color: "var(--ink-55)" }}>
          Questions? Email <a href="mailto:hello@pintaflow.com" style={{ color: "var(--seal)" }}>hello@pintaflow.com</a> — Pradeep replies personally.
        </div>
      </div>
    </div>
  );
}
